<template>
  <div>
    <documents-crud-list title="Annuaire" category="Annuaire" />
  </div>
</template>

<script>
import DocumentsCrudList from './UIComponents/DocumentsCrudList.vue';

export default {
  components: {
    DocumentsCrudList,
  },
};
</script>
